export default "__VITE_ASSET__0$GbNH7r__"